<template>
    <div class="eon-login-layout-wrapper">
        <div class="eon-logo-field">
            <EonHref label="Powrót do strony głównej" href="https://stoen.pl/" />
            <h1 class="eon-logo">
                <a href="https://stoen.pl/">
                    <img src="../../assets/logoStoenWhite.svg" alt="Przejście na stronę główną stoen.pl" />
                </a>
            </h1>
        </div>
        <router-view />
    </div>
</template>

<script>
    import EonHref from "../../components/form/EonHref";

    export default {
        name: "EonLayoutLogin",

        components: {
            EonHref,
        },
    };
</script>

<style lang="less">
@import "../assets/less/eon-layout-simple.less";
.eon-login-layout-wrapper {
    background-color: white;
    .eon-logo-field {
        display: flex;
        justify-content: space-between;
        align-items: center;
        a.href {
            font-size: 1.5rem;
        }
    }
}
</style>
